<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Сводка логов за месяц</h3>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-btn color="blue" dark small fab @click="viewGraph = !viewGraph">
            <v-icon>show_chart</v-icon>
          </v-btn>
        </v-flex>
        <template>
          <v-flex xs11 sm5>
            <template>
              <v-text-field
                v-model="date"
                prepend-icon="event"
                readonly
                @click="modalOpen = !modalOpen "
              ></v-text-field>
            </template>
            <v-dialog v-model="modalOpen" full-width width="290px">
              <v-date-picker v-model="date" type="month" scrollable locale="ru-ru">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modalOpen = !modalOpen || refresh() ">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-spacer></v-spacer>
        </template>
        <v-flex lg12>
          <!-- <template>
            <v-chart :options="option"/>
          </template>-->
          <div v-if="viewGraph">
            <e-chart
              :path-option="[
                            ['dataset.source', selectListRow],
                            ['legend.show', true],
                            ['xAxis.axisLabel.show', true],
                            ['yAxis.axisLabel.show', true],
                            ['grid.left', '2%'],
                            ['grid.bottom', '5%'],
                            ['grid.right', '3%'],
                            ['series', seriesList]
                          ]"
              height="400px"
              width="100%"
            ></e-chart>
          </div>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Поиск"
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="errorlogData"
                :rows-per-page-items="[10,25,50,100]"
                v-bind:pagination.sync="pagination"
                class="elevation-1"
                item-key="idRow"
                no-results-text="Нет результатов"
                rows-per-page-text="На странице"
                v-model="complex.selected"
                select-all
              >
                <template slot="items" slot-scope="props">
                  <tr >
                    <td>
                      <v-checkbox
                        v-model="props.selected"
                        primary
                        hide-details
                        @change="toggleItem($event)"
                      ></v-checkbox>
                    </td>
                    <td>{{ props.item.idRow }}</td>
                    <td>{{ props.item.date }}</td>
                    <td>{{ props.item.messageRow }}</td>
                    <td>{{ props.item.count }}</td>

                    <v-btn
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="blue"
                      small
                      @click="props.expanded = !props.expanded"
                    >
                      <v-icon v-if="!props.expanded">expand_more</v-icon>
                      <v-icon v-if="props.expanded">expand_less</v-icon>
                    </v-btn>
                  </tr>
                </template>
                <template slot="expand" slot-scope="props">
                  <div slot="widget-content">
                    <e-chart
                      :path-option="[
                                    ['dataset.source', props.item.dateCounts],
                                    ['legend.show', true],
                                    ['xAxis.axisLabel.show', true],
                                    ['yAxis.axisLabel.show', true],
                                    ['grid.left', '2%'],
                                    ['grid.bottom', '5%'],
                                    ['grid.right', '3%'],
                                    ['series[0].type', 'bar'],
                                    ['series[0].areaStyle', {}],
                                    ['series[0].smooth', true],
                                    ]"
                      height="400px"
                      width="100%"
                    ></e-chart>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue"; 
import API from "@/api";
import EChart from "@/components/chart/echart";
import Material from "vuetify/es5/util/colors"; 
export default {
  components: {
    EChart, 
  },
  data() {
    toggleItem: [];
    return {
      viewGraph: false,
      selectList: [[]],
      seriesList: [],
      color: Material,
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,
      modalOpen: false,
      modalData: {},  
      pagination: { sortBy: "count", descending: true }, // Сортировка по умолчанию для таблицы 
      search: "",  
      complex: {
        selected: [],
        headers: [
          {
            text: "ID",
            value: "idRow"
          },
          {
            text: "Дата",
            value: "date"
          },
          {
            text: "Сообщение",
            value: "messageRow"
          },
          {
            text: "Повторение",
            value: "count"
          },
          {
            text: "Действие",
            value: ""
          }
        ]
      }
    };
  },

  computed: {
    /**
     * Данные Лога
     * @returns {default.computed.logData|(function())|Array|getters.logData}
     */
    errorlogData() {
      return this.$store.getters["logServer/errorLogServerData"];
    },
    selectListRow() {
      return this.selectList;
    }
  },

  mounted: function() {
    /**
     * Обновляем данные при каждом открытии вкладки
     */
    this.refresh();
  },

  methods: {
    /**
     * Обновление данных по логам
     */
    refresh() {
      
      this.viewGraph = false;
      this.complex.selected = [];
      this.$store._actions["logServer/getErrorLogServerData"][0]({
        date: this.date
      });
    },

    /**
     * Выделяем строки в таблице, заполняем массив данными для графика
     */
    toggleItem() {
      this.viewGraph = false;
      this.selectList = [[]];
      this.selectList[0].push("Error");
      this.seriesList = [];

      for (let index = 1; index <= 31; index++) {
        this.selectList.push([index]);
      }

      // стили для столбцов
      this.complex.selected.forEach(item => {
        if (this.selectList[0].indexOf(item.idRow)) {
          this.selectList[0].push(item.idRow.toString());
          this.seriesList.push({ type: "bar", areaStyle: {}, smooth: true });
        }
      });

      this.complex.selected.forEach(sel => {
        let listDate = sel.dateCounts.map(item => {
          return item.date;
        });
        this.selectList.forEach(list => {
          if (listDate.indexOf(list[0]) == -1 && list[0] != "Error") {
            list.push(0);
          }
        });
        sel.dateCounts.forEach(data => {
          let idx = this.selectList.findIndex(item => item[0] === data.date);
          this.selectList[idx].push(data.count);
        });
      });
    }
  }, 
};
</script>



// WEBPACK FOOTER //
// src/pages/ui/LogError.vue